export default "__VITE_ASSET__ec5d12cc__"